import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { CapturumDropdownModule } from '@capturum/ui/dropdown';
import { ReactiveFormsModule } from '@angular/forms';
import { AsyncPipe, JsonPipe } from '@angular/common';

@Component({
    selector: 'app-dropdown',
    imports: [CapturumDropdownModule, ReactiveFormsModule, AsyncPipe, JsonPipe],
    templateUrl: './dropdown.component.html',
    styleUrl: './dropdown.component.scss'
})
export class DropdownComponent extends FieldType {}
